import React from "react";
import { useHistory } from "react-router-dom";
import { Hero } from "../../../components";
import {
	heroData,
	missionVisionData,
} from "../../../assets/data/missionVisionData";

export default function HeroSection(props) {
	const history = useHistory();

	const newData =
		history.location.pathname === "/about-us/our-mission-vision-purpose"
			? missionVisionData
			: missionVisionData.filter((data) => {
					return history.location.pathname === data.link;
			  });

	return (
		<Hero
			data={
				newData.length < 2
					? [{ ...heroData[0], heading: newData[0].heading }]
					: heroData
			}
		/>
	);
}
